//
// index.tsx
//
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// 🚀 Catch chunk loading errors before React even mounts
window.addEventListener("error", (e) => {
  const errorMessage = e.message || "";
  if (errorMessage.includes("Loading chunk") || errorMessage.includes("CSS chunk")) {
    console.warn("New deployment detected! Reloading application assets...");
    window.location.reload();
  }
});

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
